// extracted by mini-css-extract-plugin
export default {"TableRow":"Flusso_TableRow__-R3TR"};